import React, { SVGAttributes } from 'react';

export const Confetti = (props: SVGAttributes<unknown>): JSX.Element => (
  <svg width='44' height='45' viewBox='0 0 44 45' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M11.9979 9.55247L11.2217 13.4336L8.11674 10.3287L11.9979 9.55247Z' fill='#FF6678' />
    <path d='M38.2595 8.74378L36.171 11.2782L35.1167 7.79067L38.2595 8.74378Z' fill='#CA42FD' />
    <path d='M29.7466 40.7437L26.1167 42.3217L26.8938 38L29.7466 40.7437Z' fill='#FF6678' />
    <circle cx='6.81185' cy='36.6951' r='1.69512' fill='#4E8BFF' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.73978 15.016C3.4529 14.4154 2.73341 14.161 2.13275 14.4479C1.5321 14.7348 1.27773 15.4542 1.56461 16.0549L0.259511 16.6782C-0.371626 15.3568 0.187976 13.7739 1.50942 13.1428C2.83086 12.5116 4.41374 13.0712 5.04488 14.3927L3.73978 15.016Z'
      fill='#4E8BFF'
    />
    <rect
      x='23.1167'
      y='6.73436'
      width='4.28274'
      height='1.7131'
      transform='rotate(-39.677 23.1167 6.73436)'
      fill='#FF6678'
    />
    <rect
      x='12.1167'
      y='35.0631'
      width='4.28274'
      height='1.7131'
      transform='rotate(-0.843997 12.1167 35.0631)'
      fill='#CA42FD'
    />
    <rect
      x='0.116735'
      y='26.8935'
      width='3.93588'
      height='1.57435'
      transform='rotate(-28.7559 0.116735 26.8935)'
      fill='#CA42FD'
    />
    <circle cx='9.24681' cy='28.1301' r='1.13008' fill='#FF6678' />
    <circle cx='32.7467' cy='3.63' r='0.63' fill='#FF6678' />
    <circle cx='33.7467' cy='29.63' r='0.63' fill='#4E8BFF' />
    <circle cx='17.7467' cy='14.63' r='0.63' fill='#CA42FD' />
    <circle cx='28.6167' cy='27.5' r='0.5' fill='#CA42FD' />
    <circle cx='7.74674' cy='19.63' r='0.63' fill='#4E8BFF' />
    <circle cx='27.7467' cy='11.63' r='0.63' fill='#4E8BFF' />
    <circle cx='22.7467' cy='32.63' r='0.63' fill='#FF6678' />
    <circle cx='12.7467' cy='5.63' r='0.63' fill='#CA42FD' />
    <circle cx='34.2468' cy='17.1301' r='1.13008' fill='#FF6678' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M35.994 37.8161C36.4299 37.4921 36.5206 36.8761 36.1966 36.4402C35.8726 36.0044 35.2566 35.9137 34.8207 36.2377L34.1167 35.2906C35.0757 34.5778 36.4308 34.7774 37.1436 35.7363C37.8564 36.6952 37.6569 38.0504 36.6979 38.7632L35.994 37.8161Z'
      fill='#C943FF'
    />
    <path d='M41.8522 15.3331L43.588 19.0195L39.117 18.3532L41.8522 15.3331Z' fill='#4E8BFF' />
    <circle cx='19.0074' cy='1.5' r='1.5' fill='#4E8BFF' />
    <circle cx='18.2468' cy='43.1301' r='1.13008' fill='#4E8BFF' />
    <rect
      x='42.2867'
      y='28.6006'
      width='3.93588'
      height='1.57435'
      transform='rotate(-143.661 42.2867 28.6006)'
      fill='#CA42FD'
    />
  </svg>
);
